import React from 'react'
import Text from '@component/Text/Text'

export const TermsAndConditionsKorean = () => {
    return (
        <>
            <div className={'text-body1 text-gray02 dark:text-dark_gray02 px-[30px]'}>
                <Text className={'text-h2 text-gray01 dark:text-dark_gray01'}>제1장 총칙</Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 1조 (목적)</Text>
                <Text className={'mt-[10px]'}>
                    본 약관은 주식회사 위즈페이스가 제공하는 ‘리그오브트레이더스 서비스’를 이용함에 있어 회원과 회사
                    간의 권리, 의무 및 기타 제반 사항을 정함을 목적으로 합니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 2조 (용어의 정의)</Text>
                <Text className={' mt-[10px]'}>① 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</Text>
                <div className={'mt-[10px] pl-[20px]'}>
                    <Text>
                        &quot;리그오브트레이더스 서비스&quot;라 함은 회사가 개발하여 제공하는 다음 각 목에서 정의하는
                        서비스 일체로서, 회원은 단말기(PC, 휴대형 단말기 등의 각종 유무선 장치를 포함) 종류와 관계없이
                        서비스를 이용할 수 있습니다.
                        <br />
                        가. 랭킹 서비스 : 본인의 매매기록에 기반한 수익률을 타 회원들과 비교하여 시점(24시간, 7일,
                        30일)을 기준으로 수익률의 순위를 나타내는 서비스 입니다. 랭킹 서비스를 이용하고자 하는 회원은
                        자신이 사용하는 암호화폐 거래소의 API를 앱 내에 등록해야 하며, API등록 시, 랭킹 서비스를 통해
                        자신의 수익률 정보를 공개하는 것에 동의하는 것으로 간주합니다.
                        <br />
                        나. 포트폴리오 제공 서비스 : 본인의 매매결과로 발생하는 암호화폐 종목 및 매수 금액, 자산 배분
                        결과, 수익률을 타 회원이 조회할 수 있거나 이 정보를 바탕으로 자동매매 봇을 사용할 수 있도록
                        해주는 서비스 입니다. 회원은 본인의 의사에 따라 포트폴리오 정보 중 수익률 정보를 제외한 다른
                        모든 정보를 제공하거나 제공하지 않을 수 있습니다.
                        <br />
                        다. 매매내역 알림 서비스 : 본인이 공개한 포트폴리오 정보를 기반으로 암호화폐 거래소에서 매매를
                        발생시킬 경우 타 회원이 매매 내역을 실시간 알림으로 받을 수 있는 서비스를 말합니다.
                        <br />
                        라. 자동매매 봇 서비스 : 타 회원의 매매내역을 자동으로 따라 할 수 있는 서비스 입니다.
                        <br />
                        따라하기의 대상이 되는 회원은 포트폴리오 제공 서비스 및 자동매매 봇 활성화에 동의해야 합니다.
                        포트폴리오 제공 서비스 및 자동매매 봇 활성화에 동의한 경우 자신의 매매 내역을 실시간으로 온전히
                        제공하는 것에 동의하는 것으로 간주합니다. 이로인해 발생하는 모든 손실 및 불이익에 대해서 회사 및
                        자동매매 봇 이용자들은 책임지지 않습니다.
                        <br />
                        자동매매 봇을 활용하여 암호화폐 매매를 하는 경우에서 자산의 손실이 발생하는 경우에 대해 회사는
                        어떠한 책임도 지지 않습니다.
                        <br />
                        자동매매 봇을 활용하기 위해서 회원은 자신의 거래용 API (매수/매도 권한이 포함된 API)를 암호화폐
                        거래소에서 발급받아 입력하고, 자동 매매 대상을 구독 및 자동매매 봇 생성하는 과정을 거쳐야
                        합니다.
                        <br />
                        마. 회원간 암호화폐 관련 전략, 뉴스 공유 및 커뮤니티 서비스
                        <br />
                        바. 거래소 별 암호화폐 가격 정보 제공 서비스
                        <br />
                        본인의 매매결과로 발생하는 암호화폐 종목 및 매수 금액, 자산 배분 결과(이하 ‘포트폴리오 정보’)를
                        타 회원에게 알려주거나 포트폴리오 정보를 바탕으로 타인이 자동매매를 구현하게 해주는 서비스
                        입니다. 회원은 자신의 의사에 따라 포트폴리오 정보를 제공 또는 제공하지 않을 수 있습니다.
                    </Text>
                    <Text>
                        &quot;이용자&quot;라 함은 회사가 제공하는 서비스를 이용하는 자(회원, 비회원 포함)를 의미합니다.
                    </Text>
                    <Text>
                        &quot;서비스 이용계약&quot;은 이용자가 리그오브트레이더스 서비스를 이용하기 위해
                        리그오브트레이더스 웹사이트(
                        <a href="https://www.leagueoftraders.io">https://www.leagueoftraders.io</a>) 및/또는 앱 서비스를
                        통해 서비스 이용의 청약(회원가입)을 하고 회사의 승낙으로 성립하는 이용자와 회사와 계약을
                        말합니다
                    </Text>
                    <Text>
                        &quot;이용해지&quot;라 함은 회사 또는 회원이 당사자 간에 체결된 서비스 이용계약을 장래를 향하여
                        해지하는 것을 말합니다.
                    </Text>
                    <Text>
                        &quot;회원&quot;은 리그오브트레이더스 웹사이트 및/또는 앱 서비스에 접속하여 본 약관 및
                        개인정보처리방침에 동의하고 회원가입을 통해 회사와 서비스 이용계약을 체결하고, 아이디와
                        비밀번호를 부여 받아 리그오브트레이더스 서비스를 이용하는 고객을 말합니다.
                    </Text>
                    <Text>
                        &quot;회원ID&quot;라 함은 회원의 식별과 서비스 이용을 위하여 회원이 선정하고 회사가 사용을
                        승인하여 부여한 문자 또는 숫자의 조합을 말합니다.
                    </Text>
                    <Text>
                        &quot;비밀번호&quot;라 함은 회원이 부여 받은 회원ID와 일치된 회원임을 확인하고, 회원의
                        개인정보를 보호하기 위하여 회원이 정한 문자와 숫자의 조합을 말합니다.
                    </Text>
                    <Text>
                        &quot;닉네임&quot;이라 함은 회원ID 이외에 서비스를 이용하기 위해 별도로 설정 가능한 닉네임을
                        말합니다.
                    </Text>
                    <Text>
                        &quot;본인인증&quot;이라 함은 부정하고 위법한 개인정보 사용으로부터 정보주체를 보호하기 위하여
                        회원가입시 휴대폰, 공인인증서, 신용카드 등을 통하여 본인을 확인하는 것을 말합니다.
                    </Text>
                    <Text>
                        &quot;게시물&quot;이라 함은 회사의 서비스 내에 회원이 등록한 글, 사진, 동영상, 그림을 비롯한
                        각종 파일과 링크, 댓글 등의 정보를 말합니다.
                    </Text>
                    <Text>
                        &quot;운영자&quot;라 함은 회사가 제공하는 리그오브트레이더스 서비스의 전반적인 관리와 운영을
                        담당하는 자로서 회사에서 선정한 자를 말합니다.
                        <br />② 본 조 제1항에서 정의하는 사항 이외의 부분은 관계법령 및 회사가 수립하여 공지 및/또는
                        통지하는 개별 서비스 정책에서 정하는 바에 따르며, 관계법령과 개별 서비스별 정책에서 정하지
                        아니한 것은 일반적인 상관례에 따라 정의되고 해석됩니다.
                    </Text>
                </div>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 3조 (이용약관의 효력 및 변경)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 본 약관은 회사에서 운영하는 리그오브트레이더스 웹사이트 및 모바일 앱에 게시되어 공지됩니다.
                    <br />
                    ② 회원가입 시 본 약관에 동의한 경우, 회원은 동의한 때로부터 본 약관의 적용을 받게 됩니다. 웹사이트
                    및/또는 앱서비스에서 동의표시를 클릭한 경우, 본 약관에 대한 동의의사로 간주됩니다.
                    <br />
                    ③ 회사는 「약관의 규제에 관한 법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률」,
                    「개인정보보호법」, 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관련 법령에 위배하지 않는
                    범위에서 이 약관을 개정할 수 있습니다.
                    <br />
                    ④ 회사가 본 약관을 개정하는 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 서비스의
                    초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지하며, 이용자에게 불리한 내용 또는 중요한
                    내용의 개정의 경우에는 30일 이상 전부터 사전 공지하거나 전자우편으로 통지합니다.
                    <br />
                    ⑤ 회원은 개정되는 약관의 전체 또는 일부 내용에 동의하지 않을 권리가 있으며, 변경된 약관의 내용에
                    동의하지 않는 경우 회원탈퇴를 통해 이용계약을 해지할 수 있습니다. 다만, 이용계약이 해지되면 로그인
                    후 제공되는 서비스를 이용할 수 없게 됩니다.
                    <br />⑥ 회원이 개정된 약관의 효력 발생일 이전에 회원 탈퇴를 하지 않거나 서비스를 계속 이용하는 경우,
                    회사는 해당 회원이 개정된 약관에 동의한 것으로 간주합니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 4조 (약관 외 준칙)</Text>
                <Text className={'mt-[10px]'}>
                    ① 본 약관에서 명시되지 않은 사항에 대해서는 회사가 제공하는 서비스 약관의 취지, 전기통신기본법,
                    전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 청소년 보호법 기타 대한민국의 관련
                    법령 규정에 따릅니다.
                    <br />② 유료서비스를 이용하는 회원의 경우, 유료서비스에 대한 별도의 약관, 개별 정책 등 기타 회사에서
                    정하는 바에 의하여 유료 회원으로서의 권리 및 의무를 보장 또는 제한 받을 수 있습니다.
                </Text>
                <Text className={'text-h2 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    제2장 서비스 이용계약과 당사자의 의무
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    제 5조 (서비스 이용계약의 성립)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 리그오브트레이더스 서비스 이용을 희망하는 자가 본 약관 및 개인정보 취급방침 등에 대한 동의
                    및회원가입절차에 따라 서비스 이용신청을 하고, 회사가 신청한 내용을 승인하여 회원 가입절차가
                    완료됨으로써, 회사와 회원 사이의 서비스 이용계약이 성립됩니다.
                    <br />
                    ② 회원가입시 본 약관에 대한 동의는 본 약관에 대해 동의함 박스에 체크하거나 버튼을 클릭함으로써
                    동의의 의사표시가 완료 및/또는 간주됩니다.
                    <br />③ 서비스 이용계약이 성립되면 회사는 회원에게 본 약관 규정에 따라 회원ID를 부여합니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 6조 (서비스 이용신청)</Text>
                <Text className={'mt-[10px]'}>
                    ① 리그오브트레이더스 서비스 이용을 희망하는 자는 회원가입절차에서 회사가 요청하는 개인정보를
                    제공해야 합니다. 회원이 회사에 제공한 개인정보는 개인정보처리방침과 보호정책에 따라 관리되고
                    보호됩니다.
                    <br />
                    ② 회사는 본인 확인을 위해 필요시 본인인증을 요구할 수 있습니다. 이 경우 회사는 수집된 정보를 미리
                    고지한 용도 이외에는 사용하지 않습니다.
                    <br />
                    ③ 리그오브트레이더스 서비스 이용을 희망하는 자는 이용신청시 실명 및 최신의 정보를 기입하여야 하며,
                    변경사항 발생하는 경우 정보를 변경하여야 합니다. 이를 준수하지 않은 회원은 실명이 아니거나 정보가
                    부정확함으로서 발생하는 일체의 불이익에 대한 귀책사유가 인정되므로, 이로 인해 발생한 불이익에 대해
                    회사에 대한 사후적 보상이나 권리보호를 요청할 수 없습니다.
                    <br />④ 타인의 명의를 도용하여 이용신청을 한 회원의 모든 ID는 삭제됨과 동시에 관련 법령에 의해 처벌
                    받을 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 7조 (이용신청의 승인과 제한)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는, 리그오브트레이더스 서비스 이용을 희망하는 자가 회원가입절차에 따라 정확한 정보를 제공하여
                    이용신청을 하고, 이용신청 당시 리그오브트레이더스 서비스의 기술상, 관리상 조치에 문제가 없을 경우,
                    고객의 이용신청을 승낙함을 원칙으로 합니다. 단, 회사는 다음의 각 호에 해당하는 이용신청에 대해서는
                    승낙하지 않거나, 추후 확인을 통해 승낙을 취소 또는 계약을 해지할 수 있습니다.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text>실명이 아니거나 타인의 명의를 사용하여 신청할 경우</Text>
                    <Text>
                        이용신청서의 내용을 허위로 기재하여 신청하거나 회사가 제시하는 양식에 필요한 정보를 기재하지
                        않은 경우
                    </Text>
                    <Text>사회질서와 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우</Text>
                    <Text>
                        회사에 피해를 입히거나 부정한 영리 목적 등 기타 부정한 목적으로 서비스를 이용하고자 하는 경우
                    </Text>
                    <Text>
                        회사의 동의없이리그오브트레이더스 서비스를 자신의 계산으로 하는 영리사업에 활용할 목적으로
                        서비스를 이용하고자 하는 경우
                    </Text>
                    <Text>
                        본 약관에 규정한 사항을 위반하여 신청하거나 기타 회사가 정한 이용신청 요건이 미비 된 경우
                    </Text>
                    <Text>
                        기타 회원으로서 부적절한 행위를 할 우려가 있다고 인정되는 경우
                        <br />② 회사는 다음의 각 호에 해당하는 경우 이용신청에 대해서 승인을 제한할 수 있고 그 사유가
                        해소될 때까지 승인을 유보할 수 있습니다.
                    </Text>
                    <Text>서비스 설비 부족으로 단기간 내에 설비의 증설이 불가능하다고 회사가 판단할 경우</Text>
                    <Text>서비스 상에 장애가 발생한 경우</Text>
                    <Text>기타 부득이한 이유로 이용 승인이 곤란한 경우</Text>
                    <Text>최근 7일 이내에 해지 기록이 있는 회원이 재가입 신청을 하려는 경우</Text>
                </div>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 8조 (서비스 이용 제한 및 계약 해지)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회원이 서비스 이용계약을 해지하고자 할 때에는 언제든지 홈페이지 상의 회원탈퇴 신청을 통해
                    이용계약을 해지하거나 이용 중지를 요청할 수 있습니다.
                    <br />② 회사는 회원이 서비스 이용 내용에 있어서 본 약관 제 12조 내용을 위반하거나 다음 각 호에
                    해당하는 경우 회사는 이용제한 규정에 따라 이용제한 및 이용 계약을 해지할 수 있습니다.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text>정보통신 윤리위원회 등 관련 공공기관의 시정 요구가 있는 경우</Text>
                    <Text>기타 관계 법령에 위배되는 행위를 한 경우 및 회사가 정한 이용제한 규정에 해당하는 경우</Text>
                </div>
                <Text>
                    ③ 회원은 기본 서비스 홈페이지에서 서비스 운영정책 및 이용자 의무사항, 위반 시 제재 조치에 대하여
                    확인하실 수 있습니다. 회사 홈페이지를 통하여 해당 회원에게 사유를 확인 할 수 있도록 하며, 해당
                    회원은 고객센터의 절차에 따라 이의 신청을 할 수 있습니다.
                    <br />
                    ④ 미성년인 이용자의 법정대리인으로부터 요청이 있을 경우, 회사는 회원의 서비스 이용에 제한을 가할 수
                    있습니다.
                    <br />⑤ 회원탈퇴 후 재가입은 회원탈퇴 7일 후에 가능하나, 이용약관 및 정책에 의거하여 이용제한을 받은
                    회원의 경우 회사가 임의로 재가입을 거부할 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 9조 (회원정보의 변경 및 회원ID 관리)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회원은 서비스 내의 내 정보 보기 또는 해당 페이지로 링크된 메뉴를 통하여 자신의 개인정보를 관리할
                    수 있는 페이지에 접속할 수 있으며, 해당 페이지에서 언제든지 본인의 개인정보를 열람하고 수정할 수
                    있습니다. 다만, 서비스 관리를 위하여 반드시 필요한 실명, 생년월일, 성별 등은 수정할 수 없습니다.
                    또한 회사가 요청하는 경우, 이용자는 본인인증을 하거나 회사가 요구하는 본인 확인 서류를 제출하여야
                    합니다.
                    <br />
                    ② 회원ID는 원칙적으로 변경이 불가능하며, 불가피한 사유로 이를 변경하고자 하는 경우에는 해당 ID를
                    해지하고 다시 회원가입 절차를 밟아 새로운 ID로 가입하셔야 합니다.
                    <br />
                    ③ 회원은 서비스 이용을 위해 자신의 정보를 성실히 관리해야 하며 변동사항이 있을 경우 최근 상태의
                    정보로 변경하여야 합니다. 만약, 회원이 이러한 의무를 해태하여 정보 변경이 지연되거나 누락되어
                    발생하는 손해에 대하여 회사는 책임지지 않습니다.
                    <br />
                    ④ 회원ID와 비밀번호에 관한 모든 관리 책임은 회원에게 있습니다.
                    <br />
                    ⑤ 회사는 회원ID에 의하여 제반 이용자 관리 업무를 수행하므로 회원이 회원 ID를 변경하고자 하는 경우
                    회사가 인정할 만한 사유가 있어야만 회원ID를 변경 할 수 있습니다.
                    <br />⑥ 이용 고객이 등록한 회원ID 및 비밀번호에 의하여 발생되는 사용상의 과실 또는 제 3자에 의한
                    부정사용 등에 대한 모든 책임은 해당 이용 고객에게 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 10조 (개인정보 보호정책)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 관계법령이 정하는 바에 따라 회원의 등록정보를 포함한 회원의 개인정보를 보호하기 위하여
                    노력을 합니다. 회원의 개인정보보호 및 사용에 대해서는 관계법령 및 회사가 정하는 개인정보보호 정책에
                    따릅니다. 단, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보보호 정책이 적용되지
                    않습니다.
                    <br />
                    ② 회사는 회원의 귀책사유로 인해 노출된 정보에 대해서는 일체의 책임을 지지 않습니다.
                    <br />③ 회사는 본인 확인을 위해 필요 시 회원 또는 회원가입 신청자에게 그 사유를 고지하고 회원의
                    신분증 또는 이에 갈음하는 증서를 요구할 수 있습니다. 이 경우 회사는 이를 미리 고지한 용도 이외에는
                    사용하지 않습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 11조 (회사의 의무)</Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 본 약관이 정하는 바에 따라 최선을 다하여 회원에게 지속적, 안정적으로 서비스를 제공해야
                    합니다.
                    <br />
                    ② 회사는 안정적인 서비스 제공을 위하여 회사의 귀책사유 없이 설비에 장애가 발생하거나 멸실된 경우에도
                    부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구합니다.
                    <br />
                    ③ 회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보보호를 위한 보안 시스템을
                    구축하여, 개인정보보호 정책을 준수합니다.
                    <br />
                    ④ 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를
                    거쳐 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우는 이용자에게 그 사유와 처리 일정을
                    통보하여야 합니다.
                    <br />⑤ 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 회원과의 계약관계 절차 및 내용 등에 있어
                    회원에게 편의를 제공하도록 노력합니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 12조 (회원의 의무)</Text>
                <Text className={'mt-[10px]'}>
                    ① 회원은 본 약관에서 규정하는 사항과 기타 회사가 정한 제반 규정, 회사가 공지하는 사항을 준수하여야
                    합니다. 또한 회원은 회사의 업무에 방해가 되는 행위, 회사의 명예를 손상 시키는 행위를 해서는
                    안됩니다.
                    <br />
                    ② 회원의 주소, 연락처, 전자우편 주소 등 이용계약 사항이 변경된 경우에 홈페이지 혹은 모바일 앱 상에서
                    이를 수정해야 합니다. 수정을 하지 않거나 수정 지연으로 발생되는 책임은 회원에게 있습니다.
                    <br />③ 회원이 ID, 별명, 기타 서비스 내에서 사용되는 명칭 등의 선정 시에는 다음 각 호에 해당하는
                    내용을 사용하여서는 안됩니다.
                </Text>
                <div className={'pl-[20px] py-[10px]'}>
                    <Text>
                        회사가 제공하는 서비스의 공식 운영자(GM)를 사칭하거나 유사한 명칭을 사용하여 다른 이용자에게
                        혼란을 초래하는 행위
                    </Text>
                    <Text>선정적이고 음란하거나 폭력적인 내용이 포함되어 있는 명칭의 사용</Text>
                    <Text>기타 제 3자의 상표권, 저작권에 위배될 가능성이 있는 명칭의 사용</Text>
                    <Text>비어, 속어라고 판단되거나 반사회적이고 관계 법령에 저촉되는 내용이 포함된 명칭의 사용</Text>
                </div>
                <Text>
                    ④ 회원은 회사의 명시적 동의가 없는 한 서비스 이용 권한, 기타 이용 계약상의 지위를 타인에게 매도,
                    증여할 수 없으며 서비스 상의 무형자산을 담보로 제공할 수 없습니다.
                    <br />⑤ 회원은 회사에서 제공하는 서비스를 본래의 이용목적 이외의 용도로 사용해서는 안됩니다. 회원은
                    아래 각 호의 행위를 하여서는 안되며, 이에 해당되는 행위를 할 경우에는 본 약관 및 공지하는 운영정책에
                    따라 회원의 서비스 이용을 제한하거나 ID의 삭제, 수사기관의 고발 조치 등 적법한 조치를 포함한 제재를
                    가할 수 있습니다.
                </Text>
                <div className={'pl-[20px] py-[10px]'}>
                    <Text>회원 가입 또는 정보 변경 시 개인 정보를 허위로 기재하는 행위</Text>
                    <Text>타인의 개인정보를 도용하거나 부정하게 사용하는 행위</Text>
                    <Text>회원ID, 별명, 사이버 자산, 관심종목 등을 타인과 매매하거나 매매를 유도하는 행위</Text>
                    <Text>회사의 운영진 또는 직원을 사칭하는 행위</Text>
                    <Text>
                        회사로부터 특별한 권리를 받지 않고 회사의 클라이언트 프로그램을 변경하거나, 회사의 서버를 해킹
                        하거나 웹 사이트 또는 게시된 정보의 일부분 또는 전체를 임의로 변경하거나, 회사의 서비스를
                        비정상적인 방법으로 사용하는 행위
                    </Text>
                    <Text>회사의 프로그램 상의 버그를 악용하는 행위</Text>
                    <Text>회사의 사전 승낙 없이 서비스 내 또는 웹 사이트를 이용하여 판촉활동을 하는 행위</Text>
                    <Text>
                        다른 회원을 희롱 또는 위협하거나 아이템을 편취하는 등 다른 회원에게 고통, 피해 또는 불편을 주는
                        행위
                    </Text>
                    <Text>다른 회원의 개인정보를 수집 또는 저장하는 행위</Text>
                    <Text>
                        본 서비스를 통해 얻은 정보를 회사의 사전 승낙 없이 서비스 이용 외의 목적으로 복제하거나, 이를
                        출판 및 방송 등에 사용하거나, 제 3자에게 제공하는 행위
                    </Text>
                    <Text>
                        타인의 특허, 상표, 영업비밀, 저작권, 기타 지적재산권을 침해하는 내용을 전송, 게시, 전자우편 또는
                        기타의 방법으로 타인에게 유포하는 행위
                    </Text>
                    <Text>
                        청소년보호법 또는 형법에 위반되는 저속, 음란한 내용의 정보, 문장, 도형, 음향, 동영상을 전송,
                        게시, 전자우편 또는 기타의 방법으로 타인에게 유포하는 행위
                    </Text>
                    <Text>
                        심히 모욕적이거나 개인신상에 대한 내용이어서 타인의 명예나 프라이버시를 침해할 수 있는 내용을
                        전송, 게시, 전자우편 또는 기타의 방법으로 타인에게 유포하는 행위
                    </Text>
                    <Text>
                        회사가 제공하는 서비스 프로그램의 이용방식, 기획의도를 변경하거나 서비스에 비정상적으로 위해를
                        가하거나 고의로 방해하는 일체의 행위
                    </Text>
                    <Text>
                        본 약관을 포함하여 기타 회사가 정하는 제반 규정 또는 이용 조건을 위반하는 행위 및 기타 관계
                        법령에 위배되는 행위
                    </Text>
                </div>
                <Text className={'text-h2 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    제3장 서비스의 제공과 이용 등
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 13조 (서비스 제공)</Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 본 약관 제2조 제1항 각 목에 규정된 서비스를 제공합니다.
                    <br />
                    ② 회사는 이용계약이 체결된 때로부터 회원에 대한 서비스를 제공합니다. 단, 일부 서비스의 경우 회사의
                    필요에 따라 지정된 장래의 특정일자부터 서비스를 개시할 수 있습니다.
                    <br />
                    ③ 회사는 서비스를 이용하는 회원등급을 구분하여 이용시간, 이용회수, 제공 서비스의 범위 등을
                    세분화하여 이용에 차등을 둘 수 있습니다.
                    <br />
                    ④ 회사는 서비스의 향상을 위해 회원의 포트폴리오, 매매내역 등의 정보를 활용할 수 있으며, 회원의
                    동의에 따라 회원의 정보를 활용한 서비스를 다른 회원에게 제공할 수 있습니다.
                    <br />⑤ 회사가 제공하는 서비스에는 무료 서비스와 유료 서비스가 있습니다. 유료로 제공되는 서비스를
                    이용하고자 하는 회원은 각 서비스에서 제공되는 요금제를 선택하여 이용할 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    제 14조 (테스트 목적의 서비스)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 새로운 서비스를 정식으로 출시하기 전 회원들을 대상으로 일정 기간 테스트 목적의 서비스를
                    제공할 수 있습니다. 테스트 대상과 기간 및 이에 관련된 내용은 서비스 공지 사항을 통해 별도로
                    공지합니다.
                    <br />
                    ② 테스트 목적 서비스의 경우는 서비스 안정성 등을 위해 서비스 데이터의 변경, 추가, 삭제 서버 점검
                    등이 수시로 실시될 수 있으며, 테스트 기간 동안 회원이 저장한 정보 등 해당 테스트 목적 서비스와
                    관련된 모든 데이터는 초기화될 수 있습니다.
                    <br />
                    ③ 회사는 테스트 목적의 서비스 시 오류의 발견과 서비스의 안정화를 위해 이용자들이 사용하는 PC의 사양
                    정보를 수집 할 수 있습니다. 그러나, 이 경우에도 개인을 식별할 수 있는 정보와 함께 관련 정보를
                    수집하지는 않습니다.
                    <br />④ 테스트 목적의 서비스는 완성된 서비스가 아니므로, 회사는 회원이 테스트 서비스 이용시 테스트
                    과정에서 발생할 수 있는 여러가지 장애와 오류 등을 통해 손해를 입을 수 있음을 고지하여 명시하며,
                    회원은 이러한 사항을 충분히 이해하고 손해가 발생하더라도 회사를 면책하겠다는 의사를 표시한 경우에
                    한하여 테스트 목적의 서비스에 참여할 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    제 15조 (리그오브트레이더스 서비스와 회원의 암호화폐 투자행위의 관계)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 리그오브트레이더스 서비스 중 i) 포트폴리오 제공, ii)매매내역 알림, iii)자동매매 봇 서비스는
                    자본시장법상 금융투자상품을 대상으로 한 유사투자자문업이나 투자자문업, 투자일임업에 해당하지
                    않습니다.
                    <br />
                    ② 회원은 위 서비스를 활용하여 자신의 책임과 계산으로 암호화폐에 대한 투자행위를 직접 실행하는
                    것이며, 회사는 회원의 직접 투자행위에 필요한 정보와 시스템 솔루션, 프로그램을 제공합니다.
                    <br />
                    ③ 회사는 리그오브트레이더스 서비스를 통해 회원들의 자산을 모집하여 운용하지 않으며, 개별 회원을
                    대신하여 투자에 대한 판단을 내리고 회원들의 자산으로 투자행위를 실행하지 않습니다.
                    <br />④ 리그오브트레이더스 서비스는 회원들의 암호화폐 투자에 대한 매매 기록만을 제공합니다. 카피
                    봇을 포함한 모든 투자행위는 회원의 책임과 판단 하에 이뤄집니다. 회사는 리그오브트레이더스 서비스를
                    활용한 회원의 개별적인 암호화폐 투자행위에 개입하거나 암호화폐 투자행위를 권유하지 않으며,
                    암호화폐에 대한 투자자문을 수행하지 않습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 16조 (서비스의 변경)</Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부
                    서비스를 변경할 수 있습니다.
                    <br />
                    ② 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및
                    제공일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.
                    <br />③ 회사는 무료로 제공하는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단,
                    변경할 수 있으며, 이에 대하여 관계법령에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 17조 (정보의 제공)</Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 회원에게 서비스 이용에 필요가 있다고 인정되는 각종 정보에 대해서 서비스 화면에 게시하여
                    공지하거나 전자우편, 문자메시지 또는 서면발송 등의 방법으로 통지하여 회원에게 제공할 수 있습니다.
                    <br />② 회사는 서비스 개선 및 회원 대상의 서비스 소개 등의 목적으로 회원의 동의 하에 추가적인
                    개인정보를 수집하고 처리할 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 18조 (서비스 이용 시간 및 사용제한, 서비스 정기점검)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 서비스를 업무상 또는 기술상 특별한 지장이 없는 한 연중 무휴, 1일 24시간 제공하는 것으로
                    원칙으로 합니다. 단, 시스템 정기점검, 서버의 증설 및 교체 등의 운영상 필요하다고 판단되는 경우에는
                    일정기간 동안 서비스를 일시 중지할 수 있으며 이 경우 회사는 사전에 이를 홈페이지에 공지합니다.
                    <br />
                    ② 본 조 1항에도 불구하고 회사는 긴급하고 부득이한 사유로 인해 예고 없이 일시적으로 서비스를
                    제한하거나 중단 할 수 있으며, 이 경우 회사는 사후에 이를 공지할 수 있습니다. 이 경우 서비스 교체 등
                    중단 사유가 필요하다고 할 경우에는 사전에 홈페이지를 통해 공지한 후 제공되던 서비스를 일정시간 동안
                    중단할 수 있습니다.
                    <br />
                    ③ 회사는 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스
                    제공이 불가능할 경우, 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다. 다만, 이 경우 그 사유
                    및 기간 등을 회원에게 사전 또는 사후 공지합니다.
                    <br />
                    ④ 회사는 서비스를 특정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만,
                    이 경우 그 내용을 사전에 공지합니다.
                    <br />⑤ 회사는 서비스의 안정적인 제공을 위하여 필요할 경우 정기점검을 실시할 수 있으며, 정기점검의
                    일정과 시간은 홈페이지에 공지합니다.
                </Text>
                <Text className={'text-h2 font-normal mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    제4장 기타사항
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 19조 (게시물의 관리)</Text>
                <Text className={'mt-[10px]'}>
                    회사는 회원의 게시물을 소중하게 생각하며 변조, 훼손, 삭제되지 않도록 최선을 다하여 보호합니다. 다만,
                    각 호에 해당하는 경우 사전통지 없이 해당 게시물을 삭제할 수 있고, 해당 회원의 자격을 제한, 정지 또는
                    상실 시킬 수 있습니다.
                </Text>
                <div className={'pl-[20px] py-[10px]'}>
                    <Text>다른 회원 또는 제3자에게 심한 모욕을 주거나 명예를 손상시키는 내용인 경우</Text>
                    <Text>공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는 경우</Text>
                    <Text>불법복제 또는 해킹을 조장하는 내용인 경우</Text>
                    <Text>영리를 목적으로 하는 광고일 경우</Text>
                    <Text>범죄와 결부된다고 객관적으로 인정되는 내용일 경우</Text>
                    <Text>다른 이용자 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우</Text>
                    <Text>회사에서 규정한 게시물 원칙에 어긋나거나 게시판 성격에 부합하지 않는 경우</Text>
                    <Text>기타 관계 법령에 위배된다고 판단되는 경우</Text>
                </div>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 20조 (게시물에 대한 저작권)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회원이 서비스 내에 게시한 게시물의 저작권은 게시한 회원에게 귀속됩니다. 다만, 회원은 자신이 창작,
                    게시한 게시물에 대하여 회사가 서비스를 운영, 전시, 전송, 배포 또는 홍보하기 위한 목적으로 비독점적
                    사용권을 회사에게 부여합니다. 사용권은 다음과 같고, 사용권 부여는 회사가 서비스를 운영하는 동안
                    유효하며, 회원의 탈퇴 후에도 유효합니다.
                </Text>
                <div className={'pl-[20px] py-[10px]'}>
                    <Text>
                        서비스 내에서 회원 게시물의 복제, 수정, 개조, 전시, 전송, 배포, 출판 및 2차 저작물과 편집 저작물
                        작성
                    </Text>
                    <Text>
                        회사에서 제공하는 관련 서비스 내에서 회원 게시물의 복제, 수정, 개조, 전시, 배포, 출판 및 2차
                        저작물과 편집 저작물 작성
                    </Text>
                    <Text>
                        미디어, 통신사 등 서비스 제휴 파트너에게 회원의 게시물 내용을 제공, 사용하게 하는 것. 단, 이
                        경우 회사는 회원의 별명 외에 회원의 별도 동의 없이 개인정보를 제공하지 않습니다.
                    </Text>
                </div>
                <Text>
                    ② 회원은 서비스를 이용하여 취득한 정보를 임의 가공, 판매하는 행위 등 서비스에 게재된 자료를
                    상업적으로 사용할 수 없습니다.
                    <br />③ 회사는 회원이 게시하거나 등록하는 서비스 내의 내용물, 게시 내용에 대해 제 19조 각 호에
                    해당된다고 판단되는 경우 사전통지 없이 삭제할 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 21조 (광고 게재 및 광고주와의 거래)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 회원에게 지속적인 서비스를 제공하기 위해 광고 게재를 통해 수익원을 다각화 할 수 있으며,
                    이용자는 서비스 이용 시 노출되는 광고 게재에 대해 동의하는 것으로 간주됩니다.
                    <br />② 회사는 본 서비스에 게재되어 있거나 본 서비스를 통한 광고주의 판촉 활동에 이용고객이
                    참여하거나 교신 또는 거래함으로써 그 결과 발생하는 모든 손실 또는 손해에 대해 책임을 지지 않습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 22조 (커뮤니티 정책)</Text>
                <Text className={'mt-[10px]'}>
                    League of Traders를 사용한다는 것은 전 세계 사람들과 함께하는 커뮤니티의 일원이 된다는 것입니다.
                    League of Traders의 새롭고 멋진 커뮤니티 기능을 사용하려면 일정 수준 이상의 신뢰가 필요합니다.
                    수많은 League of Traders 사용자들이 이러한 신뢰를 존중하고 있으며 여러분도 책임감 있는 모습을
                    보여주시리라 믿습니다. 아래 가이드라인을 준수하시면 League of Traders를 모두에게 즐겁고 신나는
                    공간으로 유지할 수 있습니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    League of Traders에 표시되는 콘텐츠가 모두 마음에 들 수는 없을 것입니다. 콘텐츠가 부적절하다고
                    생각하시면 League of Traders팀에서 검토할 수 있도록 ‘신고’을 통해 신고해 주세요. League of
                    Traders팀에서는 신고된 콘텐츠를 연중무휴 검토하여 커뮤니티 가이드의 위반 여부를 판단합니다.
                </Text>
                <Text className={'mt-[10px]'}>커뮤니티 가이드</Text>
                <Text className={'mt-[10px]'}>
                    다음과 같은 몇 가지 상식적인 규칙을 지키면 별문제 없이 League of Traders 커뮤니티 활동을 즐기실 수
                    있으니 규정을 준수해 주시기 바랍니다. 가이드를 빠져나갈 구멍을 찾으려고 하기보다 가이드를 이해하고
                    가이드가 만들어진 근본적인 이유를 존중하세요.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>과도한 노출 및 성적인 콘텐츠</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    League of Traders에서는 포르노나 음란물을 허용하지 않습니다. 여기에 해당하는 게시물이라면 자신의
                    모습을 촬영한 것이라도 League of Traders에 올릴 수 없습니다. 또한 League of Traders는 아동 학대
                    사실을 발견했을 경우 법 집행기관과의 긴밀히 협조하여 이를 신고합니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>유해하거나 위험한 콘텐츠</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    특히 어린이와 같은 시청자가 크게 부상을 입을 수 있는 행위를 조장하는 콘텐츠를 게시하지 마세요.
                    유해하거나 위험한 행위를 보여주는 게시물은 심각한 정도에 따라 삭제될 수 있습니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>증오성 콘텐츠</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    League of Traders 서비스는 자유로운 표현을 위한 플랫폼입니다. 그러나 League of Traders는 인종이나
                    민족, 종교, 장애, 성별, 연령, 국적, 군필 여부, 계급, 성적 취향, 성 정체성에 따라 개인이나 그룹에
                    대한 폭력을 선동하거나 용납하는 콘텐츠 또는 이러한 핵심 특성을 기준으로 증오를 조장하는 콘텐츠를
                    허용하지 않습니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>폭력적이거나 노골적인 콘텐츠</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    주로 충격적이거나 선정적이거나 필요 이상의 유혈과 폭력이 난무하는 콘텐츠를 게시해서는 안 됩니다.
                    뉴스 또는 다큐멘터리 차원에서 생생히 묘사된 콘텐츠를 게시하는 경우에는 게시물 내용을 시청자가 이해할
                    수 있도록 충분한 정보를 제공하시기 바랍니다. 시청자가 특정 폭력 행위를 따라 하도록 조장하지 마세요.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>괴롭힘/사이버 괴롭힘</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    League of Traders에 악성 게시물과 댓글을 게시해서는 안 됩니다. 괴롭히는 행위가 도를 넘어 악의적
                    공격으로 간주된다면 신고되어 삭제될 수 있습니다. 약간의 짜증을 유발하거나 사소한 정도라면 무시할 수
                    있습니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>스팸, 오해를 불러일으킬 수 있는 메타데이터 및 사기</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    스팸을 좋아하는 사람은 없습니다. 조회수를 늘리기 위해 오해를 일으키는 설명, 태그, 제목 또는 미리보기
                    이미지를 만들지 마세요. 댓글을 포함하여 불특정 대상의 콘텐츠, 원치 않는 콘텐츠 또는 반복적인
                    콘텐츠를 대량으로 올리는 것은 바람직하지 않습니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>위협</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    League of Traders는 타인의 이익을 침해하는 행위, 스토킹, 협박, 괴롭힘, 위협, 사생활 침해, 타인의
                    개인 정보 누설, 폭력 행위 선동, 이용약관 위반 조장 등의 행위에 강경한 입장을 취하고 있습니다. 이러한
                    행위가 적발될 경우 가해자는 League of Traders에서 영구적으로 차단될 수 있습니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>저작권</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    저작권을 존중해 주세요. 직접 만들었거나 사용 허가를 받은 게시물만 업로드하세요. 직접 만들지 않은
                    게시물을 업로드하거나 저작권 보호를 받는 프로그램의 일부, 다른 사용자가 만든 게시물 등 다른 사람이
                    저작권을 소유하고 있는 콘텐츠가 게시물에 포함되어 있다면 필요한 승인을 받지 않고 업로드해서는 안
                    됩니다. 자세한 내용은 저작권 센터를 참조하세요.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>개인정보 보호</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    누군가가 허락 없이 내 개인정보를 게시했거나 내가 등장하는 게시물을 업로드한 경우 League of Traders
                    개인정보 보호 관련 가이드에 근거하여 콘텐츠 삭제를 요청할 수 있습니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>명의 도용</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    다른 채널이나 개인을 도용하기 위해 만든 계정은 League of Traders 명의 도용 정책에 따라 삭제될 수
                    있습니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>아동 보호</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    League of Traders 생태계에서 미성년자를 보호하기 위해 어떠한 노력을 기울이는지 알아보세요. 또한
                    League of Traders는 아동의 안전을 위협하는 상황을 발견하는 경우 법 집행기관과 긴밀히 협조해 이를
                    신고합니다.
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    <strong>추가 정책</strong>
                </Text>
                <Text className={'pl-[20px] mt-[10px]'}>다양한 주제에 관한 추가 정책입니다.</Text>
                <Text className={'pl-[20px] mt-[10px]'}>
                    League of Traders 플랫폼 안팎에서 트레이더의 행위가 League of Traders 사용자, 커뮤니티, 직원이나
                    생태계에 해를 끼치는 경우 League of Traders는 트레이더 행위의 과실이 얼마나 심각한지, 유해한 행위에
                    패턴이 존재하는지 여부를 포함하나 이에 국한되지 않는 다양한 요소를 고려하여 대처할 수 있습니다.
                    League of Traders에서는 트레이더의 권한 정지부터 계정 해지에 이르기까지 다양한 조치를 취합니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 23조 (환불규정)</Text>
                <Text className={'mt-[10px]'}>
                    환불 규정에 대해서는 앱 내 &quot;유료컨텐츠의 구매 및 환불 규정&quot;이 적용됩니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 24조 (손해 배상)</Text>
                <Text className={'mt-[10px]'}>
                    ① 회사는 회원의 서비스 이용과 관련하여서는 회사의 고의 또는 과실에 의해 발생한 회원의 손해에 대하여
                    배상할 책임이 있습니다. 그러나, 회사가 제공하는 무료 서비스 이용과 관련하여 회원에게 발생한 어떠한
                    손해에 대해서도 책임을 지지 않습니다.
                    <br />
                    ② 회사는 공정거래위원회의 &quot;소비자분쟁해결기준&quot;에 따라 유료서비스의 중지•장애로 인한 회원의
                    피해를 보상합니다.
                    <br />③ 회사가 개별 서비스 제공자와 제휴 협정을 맺고 개별서비스를 제공함에 있어 회원이 개별 서비스
                    이용약관에 동의를 한 뒤 개별서비스 제공자의 귀책 사유로 인해 손해가 발생할 경우 관련 손해에 대해서는
                    개별 서비스 제공자가 책임을 집니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 25조 (면책 조항)</Text>
                <Text className={'mt-[10px]'}>
                    ① 본 조에서 정하는 회사의 책임제한사유는 회원이 계약상 손해배상청구권 등을 행사하고자 하는 경우는
                    물론 불법행위에 기한 손해배상청구권 등을 행사하는 경우에도 적용됩니다.
                    <br />
                    ② 리그오브트레이더스 서비스는 회원들의 암호화폐 투자에 대한 일반적인 정보, 매매 기록을 제공하는
                    서비스 입니다. 회사는 리그오브트레이더스 서비스를 사용하는 회원들에게 개별적인 암호화폐 투자행위를
                    권유하지 않으며 투자자문을 수행하지 않습니다. 회원은 자신의 책임과 판단 하에 서비스 활용여부 및
                    암호화폐 투자여부를 결정합니다. 암호화폐의 가격은 시장상황과 암호화폐 관련된 각종 이슈, 각국의 규제
                    도입 등 시장 내외부의 요소에 큰 변동성을 가지므로, 리그오브트레이더스를 이용한 암호화폐 투자행위에서
                    손실이 발생할 수 있습니다. 회사는 회원의 투자손실에 대해 어떠한 책임도 지지않습니다.
                    <br />
                    ③ 회사가 제공하는 카피봇 서비스가 정상적으로 작동하기 위해서는 암호화폐 거래소와 리그오브트레이더스
                    앱이 반드시 정상적으로 실행 중이어야 하며 등록한 API도 유효해야 합니다. 회사는 카피봇 서비스를
                    활용한 회원의 암호화폐 투자가 암호화폐 거래소의 시스템의 불완전한 상태나 운영, 회원의 단말기의
                    오류나 기능장애로 인하여 발생하는 일체의 손해에 대해서 어떠한 책임을 지지 않습니다.
                    <br />
                    ④ 회사는 무료로 제공되는 서비스 이용과 관련하여 관련 법령에 특별한 규정이 없는 한 책임을 지지
                    않습니다.
                    <br />
                    ⑤ 회사는 전시, 사변, 천재지변, 국가비상사태, 해결이 곤란한 기술적 결함, 디도스 공격,
                    기간통신사업자가 전기통신서비스를 중지하거나 정상적으로 제공하지 아니하는 등 기타 불가항력 사유로
                    서비스를 제공할 수 없는 경우에는 책임이 면제됩니다.
                    <br />
                    ⑥ 회사는 사전에 공지된 서비스용 설비의 보수, 교체, 정기점검, 공사, 테스트 목적의 서비스 제공 중
                    개선과정이나 오류발생 등 부득이한 사유로 서비스가 중지되거나 장애가 발생한 경우에 대해서는 책임이
                    면제됩니다.
                    <br />
                    ⑦ 회사는 회원의 귀책사유로 인한 서비스의 중지/이용장애에 대하여 책임을 지지 않습니다.
                    <br />
                    ⑧ 회원은 당사 제공 서비스 관련하여 자신이 회사에 등록한 항목(전자우편주소, 이동전화번호 등) 및
                    비밀번호 보안에 대한 책임을 지며, 회사는 회사의 고의 또는 과실 없이 ID, 비밀번호 등의 회원정보가
                    유출되어 발생하는 손해에 대해 책임을 지지 않습니다.
                    <br />
                    ⑨ 회사는 회원의 컴퓨터나 단말기 환경으로 인하여 발생하는 제반 문제 또는 회사의 귀책사유가 없는
                    네트워크 환경으로 인하여 발생하는 문제에 대해서는 책임을 지지 않습니다.
                    <br />
                    ⑩ 회사는 회원이 서비스 내 또는 웹 사이트에 게시 또는 전송한 정보, 자료, 사실의 신뢰도, 정확성 등
                    내용에 대해서는 책임을 지지 않습니다.
                    <br />
                    ⑪ 회사는 회원 상호간 또는 회원과 제 3자간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며
                    이로 인한 손해를 배상할 책임도 없습니다.
                    <br />
                    ⑫ 회사는 다른 이용자 또는 제3자가 작성한 문서 또는 사이트에 게시한 게시물, 제공한 정보, 전송한
                    자료로 인해 이용자에게 발생한 손해에 대해서는 책임을 지지 않습니다.
                    <br />⑬ 회원이 서비스를 이용함에 있어 회원 본인이 행한 불법행위나 이 약관 위반행위로 인하여 회사가
                    해당 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 해당 회원은
                    자신의 책임과 비용으로 반드시 회사를 면책 시켜야 합니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>제 26조 (기타사항)</Text>
                <Text className={'mt-[10px]'}>
                    ① 본 약관에 명시되지 않은 사항이 관계 법령에 규정되어 있을 경우에는 해당 규정에 따릅니다.
                    <br />
                    ② 회사의 유료 서비스 회원의 경우 회사가 별도로 정하는 유료 서비스 이용약관이나 유료 서비스
                    이용정책이 적용될 수 있습니다.
                    <br />
                    ③ 서비스 이용과 관련하여 회사와 이용자간에 발생한 분쟁에 관한 소송은 민사소송법 등 관련 법률상의
                    관할법원에 제기합니다.
                    <br />④ 회사와 회원간에 제기된 소송은 대한민국 법을 적용합니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    제 27조 (광고성 정보 수신)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 리그오브트레이더스가 제공하는 이용자 맞춤형 서비스, 각종 경품 행사, 이벤트 등의 광고성 정보를
                    전자우편이나 서신우편, 문자(SMS 또는 카카오 알림톡), 푸시, 전화 등을 통해 이용자에게 제공합니다.
                    <br />② 광고성 정보 수신 동의 여부는 리그오브트레이더스 서비스의 설정에서 동의 또는 비동의 상태로
                    변경할 수 있습니다.
                </Text>
                <hr className={'border-none'} />
                <Text className={'mt-[10px] text-gray01 dark:text-dark_gray01'}>주식회사 위즈페이스</Text>
                <Text className={'mt-[10px]'}>시행일: 2019년 8월 8일</Text>
            </div>
        </>
    )
}
